import type { Tour } from '../tour-types';

/**
 * Health, across every account the viewer can reach. The accounts anchor is on the first
 * account card only, so it drops out when nothing is listed; the item anchor is on the
 * first problem in that card, and drops out when the card has none.
 *
 * The only monitor tour that points at the shared scope picker: here Only mine also
 * changes which accounts are listed, which the other monitors do not.
 */
export const healthTour: Tour = {
  key: 'health',
  version: 1,
  routes: ['/health'],
  steps: [
    {
      anchor: 'health-scope',
      placement: 'bottom',
      title: 'Whose experiments',
      body: 'Look across every account, only the one picked in the header, or only the experiments you created or started. Only mine also hides the accounts with none of yours.',
    },
    {
      anchor: 'health-tiles',
      placement: 'bottom',
      title: 'What needs you',
      body: 'Pick Needs a decision or Broken to list only those experiments, and pick it again to see everything. Running opens the full list of live experiments in the library.',
    },
    {
      anchor: 'health-accounts',
      placement: 'top',
      title: 'Accounts',
      body: 'Each account counts what is broken, waiting on a decision or waiting to be built, and lists its websites with something running. Open a website to go to its dashboard.',
    },
    {
      anchor: 'health-item',
      placement: 'top',
      title: 'Something to fix',
      body: 'One experiment that needs a person, with the reason beside it. Red is broken and its results should not be trusted; open it to deal with it.',
    },
  ],
};
